@layer components {
    .clickable {
        cursor: pointer;
    }
}
